import menuTypes from 'common/constants/menuTypes';
import { coreTranslations } from 'translations';

const configureMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_configure,
        linkTitle: 'Configure',
        icon: 'onsolve-configure-icon',
        routeTo: '/configure',
        isRenderable: true,
        children: _subMenu(),
        menuType: menuTypes.secondary,
        newNav: true
    };
}

function _subMenu() {
    return [
        {
            i18n: coreTranslations.ng_core_shapesLibrary,
            linkTitle: 'Shapes Library',
            routeTo: '/shapes-library',
            isEnabled: true,
            isRenderable: true,
            accessConfiguration: permissions => permissions.canViewShapesLibrary(),
            newNav: true
        }
    ];
}

export default configureMenuItems;
